import React from 'react';
import "./styles.css";
import digiAqua from '../../assets/digiAqua.png';
import Profile from './Profile'

const Header = ({handleUserProfile, handleLogin}) => {
    return(
        <div className="main-header">
            <img style = {{marginLeft:'20px', height:'9vh'}} src={digiAqua} alt="digiAqua"/>
             <Profile handleProfileClick={handleUserProfile} handleLogin={handleLogin}/>
        </div>
    )
}

export default Header;